import { render } from "./prescriptionTemplate.vue?vue&type=template&id=9669b88a&scoped=true"
import script from "./prescriptionTemplate.vue?vue&type=script&lang=js"
export * from "./prescriptionTemplate.vue?vue&type=script&lang=js"

import "./prescriptionTemplate.vue?vue&type=style&index=0&id=9669b88a&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9669b88a"]])

export default __exports__